module.exports = __webpack_public_path__ + "img/taxi_day_up_selected.16bd5bbc.svg";